import React from 'react';
import * as Yup from 'yup';
import { Text } from '@rsos/components/capstone/base';

export const schema = Yup.object().shape({
  authorityName: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
      id: Yup.number().required(),
    })
    .nullable()
    .required('Authority name is required'),
  alertTypes: Yup.array().min(1, 'Pick at least 1 alert type'),
});

export const agencyPairStatus = status => {
  const capitalizedStatus = status.charAt(0).toUpperCase() + status.slice(1);
  const colorMapper = {
    active: 'success',
    pending: 'secondaryText',
    declined: 'lightDanger',
  };
  return (
    <Text color={colorMapper[status] || 'secondaryText'} size="normal">
      {capitalizedStatus}
    </Text>
  );
};
